module.exports = __webpack_public_path__ + "img/search-black.0f17bbc2.svg";